import React from "react";
import '../styles/components/YouSearch.css'

const YouSearch = () => {

    return (
        <>
            <div className='you-search'>
                <h1>أبحــث عـن مستشــار خبيـــر...</h1>
                <h2>فقط أرســل لي رسالة!</h2>
                <a className='button'>تواصـل معــي</a>
            </div>
        </>
    )

}

export default YouSearch